// extracted by mini-css-extract-plugin
export default {"footerBasic":"Footer_footerBasic__n4js-","social":"Footer_social__MfQNF","copyright":"Footer_copyright__2WB24"};